export const QUOTATION_GET_PRE_QUOTATION_VALUES =
    "@QUOTATION/GET_PRE_QUOTATION_VALUES";

export const QUOTATION_GET_PRE_QUOTATION_VALUES_DONE =
    "@QUOTATION/GET_PRE_QUOTATION_VALUES_DONE";

export const CALCULATE_QUOTATION = "@QUOTATION/CALCULATE_QUOTATION";

export const CALCULATE_QUOTATION_DONE = "@QUOTATION/CALCULATE_QUOTATION_DONE";

export const UPDATE_INITIAL_MONTH_QUOTATION =
    "@QUOTATION/UPDATE_INITIAL_MONTH_QUOTATION";

export const QUOTATION_IS_VALID = "@QUOTATION/QUOTATION_IS_VALID";

export const QUOTATION_SELECT_PRIME = "@QUOTATION/QUOTATION_SELECT_PRIME";

export const SAVE_QUOTATION = "@QUOTATION/SAVE_QUOTATION";

export const SAVE_QUOTATION_DONE = "@QUOTATION/SAVE_QUOTATION_DONE";

export const HIDE_QUOTATION_LOADING = "@QUOTATION/HIDE_QUOTATION_LOADING";

export const CLEAR_QUOTATION = "@QUOTATION/CLEAR_QUOTATION";

export const LOADING_QUOTATION = "@QUOTATION/LOADING_QUOTATION";
